import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { StorageApi } from 'services/storage';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import LocationIcon from 'sub_components/Storage/LocationIcon';
import { IconButton } from 'styled_components/Common/IconButton';
import { STORAGE_ICONS } from 'utils/StorageConstants';
import { A1 } from 'styled_components/Storage/Icons/A1';
import { BloxButton } from 'styled_components/Common/BloxButton';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;
const RedundancyIcon = `${CDN_URL}storage/Storage-mirror-arrows-green.svg`;

function calculatePercentage(shareSize, total) {
	const percentage = ((shareSize / total) * 100) / 1;

	return { percentage };
}
const ShareBackSideStyle = styled.button`
	width: 100%;
	height: 100%;
	background: transparent;
	border: none;
	.flip-card-button {
		position: absolute;
		z-index: 1000;
		top: 10px;
		right: 10px;
	}
	#view-more {
		position: absolute;
		bottom: 25px;
		margin-left: 70px;
	}
	.redundancy {
		display: none;
		align-items: center;
		justify-content: center;
		margin-top: 8px;
		.primaryLocation,
		.secondaryLocation,
		.generic-location,
		.redundancy-icon {
			width: 30px;
			height: 30px;

			img {
				width: 20px;
				height: 20px;
			}
		}
		.redundancy-icon {
			margin-bottom: -30px;
		}
	}
	.name-icon-section {
		margin-top: 5px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		svg {
			margin-bottom: 8px;
			width: 25px;
			height: 25px;
		}
	}
	.total-usage {
		color: ${props => props.theme.$DCBLOX_Gray};
		margin-top: 8px;
		flex: 0 1 100px;
		flex-basis: 100px;
		.total {
			display: none;
		}
		.circle {
			width: 120px;
			height: 100px;
		}
		.new-title {
			align-self: center !important;
			color: ${props => props.theme.$DCBLOX_Gray};
			padding-top: 0.5vh;
		}
		.count {
			@include Numbers20;
			z-index: 3000;
			color: ${props => props.theme.$DCBLOX_Gray};
		}
		.CircularProgressbar {
			width: 100px;
			height: 100%;
		}
		.CircularProgressbar + div {
			top: 0;
			margin-top: 0 !important;
		}
		.CircularProgressbar-path {
			stroke: ${props => props.theme.storage};
		}
		.CircularProgressbar-trail {
			stroke: ${props => props.theme.Cool_Gray_Med_3};
		}
		.CircularProgressbar-background {
			fill: white;
		}
		.progress-background {
			z-index: 100;
		}
		.total-indicator-quick-view-progress {
			fill: white;
		}
		.percentage {
			@include Text-Style-Form-Ghost-Text;
		}
		.type {
			@include Text-Style-Status-Head;
		}
		text {
			fill: red;
		}
		.indicator-open-count {
			margin-left: -1vw;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 384px;
		.flip-card-button {
			top: 10px;
			right: 10px;
			img {
				width: 15px;
				height: 15px;
			}
		}
		#view-more {
			margin-left: 120px;
			bottom: 22px;
		}
		.redundancy {
			display: flex;
			margin-top: 8px;
			.primaryLocation,
			.secondaryLocation,
			.generic-location,
			.redundancy-icon {
				width: 35px;
				height: 35px;

				img {
					width: 35px;
					height: 35px;
				}
			}
			.redundancy-icon {
				margin-bottom: -44px;
				margin-left: 10px;
				margin-right: 10px;
			}
		}
		.name-icon-section {
			margin-top: 2px;

			svg {
				margin-bottom: 8px;
				width: 40px;
				height: 40px;
			}
		}
		.total-usage {
			margin-top: -95px;
			flex: 0 1 150px;
			flex-basis: 150px;
			.total {
				display: none;
			}
			.circle {
				width: 150px;
				height: 100px;
			}
			.new-title {
				align-self: center !important;
				color: ${props => props.theme.$DCBLOX_Gray};
				padding-top: 0.5vh;
			}
			.count {
				@include Numbers20;
				z-index: 3000;
				color: ${props => props.theme.$DCBLOX_Gray};
			}
			.CircularProgressbar {
				width: 150px;
				height: 100%;
			}

			.indicator-open-count {
				margin-left: -1vw;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.flip-card-button {
			top: 15px;
			right: 15px;
			img {
				width: 15px;
				height: 15px;
			}
		}
		#view-more {
			margin-left: 225px;
			bottom: 40px;
		}
		.redundancy {
			display: flex;
			margin-top: 15px;
			.primaryLocation,
			.secondaryLocation,
			.generic-location,
			.redundancy-icon {
				width: 45px;
				height: 45px;

				img {
					width: 45px;
					height: 45px;
				}
			}
			.redundancy-icon {
				margin-bottom: -37px;
				margin-left: 30px;
				margin-right: 30px;
			}
		}
		.name-icon-section {
			margin-top: 15px;

			svg {
				margin-bottom: 15px;
				width: 90px;
				height: 90px;
			}
		}
		.total-usage {
			margin-top: 0px;
			flex: 0 1 200px;
			flex-basis: 200px;
			.total {
				display: none;
			}
			.circle {
				width: 200px;
				height: 100px;
			}
			.new-title {
				align-self: center !important;
				color: ${props => props.theme.$DCBLOX_Gray};
				padding-top: 0.5vh;
			}
			.count {
				@include Numbers20;
				z-index: 3000;
				color: ${props => props.theme.$DCBLOX_Gray};
			}
			.CircularProgressbar {
				width: 200px;
				height: 100%;
			}

			.indicator-open-count {
				margin-left: -1vw;
			}
		}
	}
`;

export const ShareBackSide = ({ share, onClick, total, unit, orgId, navigate }) => {
	const shareSize = share?.[`currentSize${unit}`];
	const { percentage } = calculatePercentage(shareSize, total);
	const [locations, setLocations] = useState([]);
	const getShare = async () => {
		const {
			storageDetails: { locations },
		} = await StorageApi.get(share?.id, orgId);

		setLocations(locations);
	};
	useEffect(() => {
		getShare();
	}, [share]);
	const primaryLocation = locations && locations.filter(location => location?.primary);
	const secondaryLocation = locations && locations.filter(location => !location?.primary);
	const Icon = STORAGE_ICONS[share?.mainIcon] ? STORAGE_ICONS[share?.mainIcon] : A1;

	return (
		<ShareBackSideStyle className='share-back-side' data-cy='share-back-side'>
			<div className='flip-card-button'>
				<IconButton
					enabled={true}
					id='icon-button'
					module='storage'
					onClick={onClick}
					style={{ cursor: 'pointer' }}
				>
					<img data-cy='close-button' src={CloseIcon} alt='' />
				</IconButton>
			</div>
			<div className='total-usage'>
				<CircularProgressbarWithChildren
					value={percentage}
					background={true}
					styles={buildStyles({
						strokeLinecap: 'butt',
					})}
				>
					<div className='count' style={{}}>
						{shareSize ? shareSize.toFixed(1) : 0}
					</div>
					<div className='new-title' style={{ marginTop: -5 }}>
						{unit}
					</div>
				</CircularProgressbarWithChildren>
			</div>
			<div className='name-icon-section'>
				<Icon color={share?.iconColor ? share?.iconColor : '#00b0b9'} />
				<div className='name heading-section-head'>{share.name}</div>
			</div>

			{share?.replication && locations.length !== 0 && (
				<div className='redundancy'>
					<div className='primaryLocation'>
						<LocationIcon location={primaryLocation[0]?.tag} />
					</div>
					{secondaryLocation && (
						<>
							<img src={RedundancyIcon} className='redundancy-icon' />
							<div className='secondaryLocation'>
								<LocationIcon location={secondaryLocation[0]?.tag} />
							</div>{' '}
						</>
					)}
				</div>
			)}

			{!share.replication && locations.length !== 0 && (
				<div className='redundancy'>
					<div className='primaryLocation'>
						<LocationIcon location={primaryLocation[0]?.tag} />
					</div>
				</div>
			)}
			<BloxButton
				className='buttons41'
				id='view-more'
				text='View More'
				module='storage'
				enabled={true}
				onClick={() => navigate(`/portal/storage/share_detail/${share?.id}`)}
				cypressId='okay'
			/>
		</ShareBackSideStyle>
	);
};
